<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12K84Rc/Images/OnceAHero_coverSMALL.jpg?1734954337376" alt="This image is the cover for the book Once a Hero, The Kincaids"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Once a Hero, The Kincaids
      </h1>
      <p class="bookDescription body article font2">
        <p>“Raine Cantrell is a superb storyteller whose remarkable talent for recreating the West will hold you enthralled.” —<i>RT Book Reviews</i><br/><br/><b>Even an adopted Kincaid can’t stop himself from helping a woman in need. Luckily for Kee, Isabel isn’t much for needing. </b><br/><br/> Kee Kincaid never set out to be a hero.<br/><br/> He’s just not a man who can run from a woman in distress. And Isabel del Cuervo is in the worst distress of her life. When Kee stumbles on her being wrangled like cattle by two strange men, he can’t help but ride in guns blazing and rescue her. <br/><br/> Accused of thievery and holding a map to a fortune of gold, there isn’t much about Isabel Kee can trust, but her dark blue eyes hide more than just secrets. Somewhere in that tumultuous ocean is a plea for help. And a Kincaids never denies a plea for help.<br/><br/> Now he’s on the search for a treasure (that may not exist) on a map (that may not be accurate anymore). As Kee finds himself more intrigued by Isabel’s company than the glitter of gold, he knows the greatest danger on this journey isn’t the treacherous trail, but the woman ebbing away at his loner facade.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Raine Cantrell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1af73190